import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import TFUSelect from "../based/inputs/TFUSelect";
import AccountServices from "../based/services/AccountServices";
import { Notify } from "../based/Notify";
import { NOTIFY } from "../based/Constants";
import TFUOverlay from "../based/inputs/TFUOverlay";
import addbot from "./assets/addbot.jpg";
import newgroup from "./assets/newgroup.jpg";
import starbot from "./assets/starbot.jpg";

const OverLayObject = {
    Step1: 1,
    Step2: 2,
    Step3: 3,
    Step4: 4,
    Step5: 5,
};

function GroupNotiModal({ show, onClose, onSave }) {
    const [groupTypeOptions, setGroupTypeOptions] = useState([]);
    const [selectOption, setSelectOption] = useState(null);
    const [selectedOverlay, setSelectedOverlay] = useState(0);

    useEffect(() => {
        if (show) getListGroupType();
    }, [show]);

    const getListGroupType = async () => {
        const [err, data] = await AccountServices.GetGroupTelegramByPartner();
        if (!err && data) {
            let options = data.map((item) => ({ ...item, label: item.groupTypeName, value: item.id }));
            setGroupTypeOptions(options);
            //auto select first item
            if (options.length > 0) {
                setSelectOption(options[0].value);
            }
        } else {
            setGroupTypeOptions([]);
        }
    };

    const linkConnect = useMemo(() => {
        if (selectOption >= 0) {
            const selectedItem = groupTypeOptions.find((item) => item.id === selectOption);
            if (selectedItem) {
                return `https://t.me/${selectedItem.botName}?startgroup=${selectedItem.code}`;
            }
        }
        return "";
    }, [selectOption]);

    return (
        <CommonModal show={show} onClose={onClose} hiddenFooter size="md" hideClose>
            <Wrapper>
                <div className="header">
                    <div className="title">Tạo nhóm thông báo mới</div>
                    <div className="close-btn">
                        <i className="fa fa-2x fa-times" onClick={onClose}></i>
                    </div>
                </div>
                <div className="body">
                    <div className="step">
                        <p>
                            Bước 1: Tạo nhóm để nhận thông báo trên Telegram{" "}
                            <i
                                className="fa fa-question-circle overlay-1 cursor-pointer"
                                onMouseEnter={() => setSelectedOverlay(OverLayObject.Step1)}
                                onMouseLeave={() => setSelectedOverlay(0)}
                                onClick={() => setSelectedOverlay(OverLayObject.Step1)}
                            ></i>
                        </p>
                        <TFUOverlay
                            show={selectedOverlay === OverLayObject.Step1}
                            target={document.querySelector(".overlay-1")}
                            container={document.querySelector(".body")}
                            placement="bottom"
                            content={() => (
                                <div className="overlay-content">
                                    <img src={newgroup} alt="" />
                                </div>
                            )}
                        />
                    </div>
                    <div className="step">
                        <p>Bước 2: Chọn loại nhóm thông báo</p>
                        <div className="select">
                            <TFUSelect placeholder="Chọn loại nhóm" options={groupTypeOptions} value={selectOption} onChanged={(value) => setSelectOption(value)} />
                        </div>
                    </div>
                    <div className="step" style={{ marginBottom: "10px" }}>
                        <p>Bước 3: Kết nối với Botchat Telegram Ranus</p>
                        <div className="barcode-section">
                            <div className="link-code">
                                <a
                                    href=""
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }}
                                >
                                    {linkConnect}
                                </a>
                                <button
                                    className="copy-link btn"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (linkConnect) {
                                            navigator.clipboard.writeText(linkConnect);
                                            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Đã sao chép đường dẫn kết nối đến clipboard");
                                        }
                                    }}
                                >
                                    <span>
                                        <i className="fa fa-copy"></i> Copy Link
                                    </span>
                                </button>
                            </div>
                            <button
                                className="connect-link btn"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (linkConnect) {
                                        window.open(linkConnect, "_blank");
                                    } else {
                                        Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Vui lòng chọn loại nhóm trước khi kết nối!");
                                    }
                                }}
                            >
                                <span>
                                    <i className="fa fa-connectdevelop"></i> Kết nối
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="step">
                        <p>
                            Bước 4: Nhấn vào “Start Bot” để kết nối{" "}
                            <i
                                className="fa fa-question-circle overlay-4 cursor-pointer"
                                onMouseEnter={() => setSelectedOverlay(OverLayObject.Step4)}
                                onMouseLeave={() => setSelectedOverlay(0)}
                                onClick={() => setSelectedOverlay(OverLayObject.Step4)}
                            ></i>
                        </p>
                        <TFUOverlay
                            show={selectedOverlay === OverLayObject.Step4}
                            target={document.querySelector(".overlay-4")}
                            container={document.querySelector(".body")}
                            placement="bottom"
                            content={() => (
                                <div className="overlay-content">
                                    <img src={starbot} alt="" />
                                </div>
                            )}
                        />
                    </div>
                    <div className="step">
                        <p>
                            Bước 5: Chọn nhóm vừa tạo và chọn OK để hoàn thành{" "}
                            <i
                                className="fa fa-question-circle overlay-5 cursor-pointer"
                                onMouseEnter={() => setSelectedOverlay(OverLayObject.Step5)}
                                onMouseLeave={() => setSelectedOverlay(0)}
                                onClick={() => setSelectedOverlay(OverLayObject.Step5)}
                            ></i>
                        </p>
                        <TFUOverlay
                            show={selectedOverlay === OverLayObject.Step5}
                            target={document.querySelector(".overlay-5")}
                            container={document.querySelector(".body")}
                            placement="bottom"
                            content={() => (
                                <div className="overlay-content">
                                    <img src={addbot} alt="" />
                                </div>
                            )}
                        />
                    </div>
                </div>
                <div className="btn-footer">
                    <div className="lst-button">
                        <button
                            className="btn btn-close"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onClose();
                            }}
                        >
                            Đóng
                        </button>
                        <button
                            className="btn btn-orange"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (selectOption) {
                                    onSave(selectOption);
                                } else {
                                    Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Vui lòng chọn loại nhóm trước khi hoàn thành!");
                                }
                            }}
                        >
                            Hoàn thành
                        </button>
                    </div>
                </div>
            </Wrapper>
        </CommonModal>
    );
}

export default GroupNotiModal;

const Wrapper = styled.div`
    .link-code {
        width: 100%;
    }

    .overlay-content img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    button.copy-link.btn {
        margin-left: auto;
    }

    .header {
        display: flex;
        align-items: center;
        padding: 12px 20px;
        border-bottom: 1px solid #f3f3f3;
    }

    .title {
        margin-left: auto;
        color: #333;
        text-align: center;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    .close-btn {
        margin-left: auto;
        width: 24px;
        display: flex;
        align-items: center;
    }

    .body {
        padding: 18px 24px;
    }

    .step {
        position: relative;
    }

    .step p {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 0 0 10px 0;
    }

    .select {
        margin-bottom: 10px;
    }

    .barcode-section {
        display: flex;
        align-items: center;
    }

    button.connect-link.btn {
        margin-left: 10px;
    }

    .link-code {
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
        display: flex;
        align-items: center;
    }

    .link-code a {
        padding-left: 6px;
        display: flex;
        align-items: center;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    button.copy-link.btn {
        /* flex: 1; */
        height: 100%;
    }

    .btn-footer {
        border-radius: 0px 0px 12px 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        box-shadow: 0px -2px 30px 0px rgba(0, 0, 0, 0.1);
        padding: 10px;
        display: flex;
    }

    .lst-button {
        margin-left: auto;
    }

    button.btn.btn-close {
        border-radius: 40px;
        border: 1px solid #e5e5e5;
        background: #f3f3f3;
        margin: 0 4px;
    }

    button.btn.btn-orange {
        border-radius: 40px;
        background: #ff9027;
        color: #fff;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin: 0 4px;
    }
`;
